// Static course data for immediate rendering (fallback when API is slow/unavailable)
const STATIC_COURSES = [
  {
    course_id: "c_english", slug: "english-language",
    title: "Learn English Language Course", category: "Language Courses",
    short_description: "Build fluency, grammar & confidence in spoken and written English.",
    long_description: "A comprehensive English program covering grammar, vocabulary, pronunciation, conversation practice and written communication.",
    instructor_id: "i_priya", instructor_name: "Priya Menon",
    instructor_avatar: "https://api.dicebear.com/7.x/personas/svg?seed=PriyaMenon",
    duration: "25 Hours", level: "All Levels", language: "English",
    price: 399, original_price: 799, rating: 4.9, students_enrolled: 8420,
    image_url: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=800&q=80",
    badge: "Language Courses", tags: ["English"],
    learning_outcomes: ["Speak English confidently"],
    requirements: ["Basic English"],
    lessons: [{ lesson_id: "l1", title: "Foundations", duration: "45m", video_url: "https://www.youtube.com/embed/dQw4w9WgXcQ", description: "Core rules.", order: 1 }],
  },
  {
    course_id: "c_hindi", slug: "hindi-language",
    title: "Learn Hindi Language Course", category: "Language Courses",
    short_description: "Learn Hindi from scratch.",
    long_description: "Master Hindi with structured lessons.",
    instructor_id: "i_rahul", instructor_name: "Rahul Verma",
    instructor_avatar: "https://api.dicebear.com/7.x/personas/svg?seed=RahulVerma",
    duration: "25 Hours", level: "All Levels", language: "Hindi",
    price: 299, original_price: 599, rating: 4.8,
    image_url: "https://images.unsplash.com/photo-1590086782957-93c06ef21604?auto=format&fit=crop&w=800&q=80",
    badge: "Language Courses", tags: ["Hindi"],
    lessons: [{ lesson_id: "l1", title: "Basics", duration: "45m", video_url: "https://www.youtube.com/embed/dQw4w9WgXcQ", description: "Alphabet.", order: 1 }],
  },
  {
    course_id: "c_kannada", slug: "kannada-language",
    title: "Learn Kannada Language Course", category: "Language Courses",
    short_description: "Learn Kannada.",
    long_description: "A practical Kannada course.",
    instructor_id: "i_kavya", instructor_name: "Kavya Sharma",
    instructor_avatar: "https://api.dicebear.com/7.x/personas/svg?seed=KavyaSharma",
    duration: "25 Hours", level: "All Levels", language: "Kannada",
    price: 299, original_price: 599, rating: 4.8,
    image_url: "https://images.unsplash.com/photo-1600100397608-f010f423b971?auto=format&fit=crop&w=800&q=80",
    badge: "Language Courses", tags: ["Kannada"],
    lessons: [{ lesson_id: "l1", title: "Basics", duration: "50m", video_url: "https://www.youtube.com/embed/dQw4w9WgXcQ", description: "Alphabet.", order: 1 }],
  },
  {
    course_id: "c_french", slug: "french-language",
    title: "Learn French Language Course", category: "Language Courses",
    short_description: "Speak elegant French.",
    long_description: "Comprehensive French program.",
    instructor_id: "i_chloe", instructor_name: "Chloé Dubois",
    instructor_avatar: "https://api.dicebear.com/7.x/personas/svg?seed=ChloeDubois",
    duration: "30 Hours", level: "All Levels", language: "French",
    price: 499, original_price: 999, rating: 4.9,
    image_url: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=800&q=80",
    badge: "Language Courses", tags: ["French"],
    lessons: [{ lesson_id: "l1", title: "Bonjour!", duration: "35m", video_url: "https://www.youtube.com/embed/dQw4w9WgXcQ", description: "Welcome.", order: 1 }],
  },
  {
    course_id: "c_german", slug: "german-language",
    title: "Learn German Language Course", category: "Language Courses",
    short_description: "Goethe-aligned curriculum.",
    long_description: "Structured German program.",
    instructor_id: "i_kavya", instructor_name: "Kavya Sharma",
    instructor_avatar: "https://api.dicebear.com/7.x/personas/svg?seed=KavyaSharma",
    duration: "30 Hours", level: "All Levels", language: "German",
    price: 499, original_price: 999, rating: 4.9,
    image_url: "https://images.unsplash.com/photo-1599946347371-68eb71b16afc?auto=format&fit=crop&w=800&q=80",
    badge: "Language Courses", tags: ["German"],
    lessons: [{ lesson_id: "l1", title: "Hallo!", duration: "38m", video_url: "https://www.youtube.com/embed/dQw4w9WgXcQ", description: "Start.", order: 1 }],
  },
  {
    course_id: "c_japanese", slug: "japanese-language",
    title: "Learn Japanese Speaking Course", category: "Language Courses",
    short_description: "Hiragana to Kanji.",
    long_description: "Speak Japanese with confidence.",
    instructor_id: "i_ayumi", instructor_name: "Ayumi Tanaka",
    instructor_avatar: "https://api.dicebear.com/7.x/personas/svg?seed=AyumiTanaka",
    duration: "40 Hours", level: "All Levels", language: "Japanese",
    price: 499, original_price: 999, rating: 4.9,
    image_url: "https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&w=800&q=80",
    badge: "Language Courses", tags: ["Japanese"],
    lessons: [{ lesson_id: "l1", title: "Hiragana", duration: "1h 30m", video_url: "https://www.youtube.com/embed/dQw4w9WgXcQ", description: "Basics.", order: 1 }],
  },
  {
    course_id: "c_maths", slug: "mathematics",
    title: "Mathematics", category: "Academic Courses",
    short_description: "Strengthen your maths.",
    long_description: "Structured mathematics program.",
    instructor_id: "i_arjun", instructor_name: "Arjun Kapoor",
    instructor_avatar: "https://api.dicebear.com/7.x/personas/svg?seed=ArjunKapoor",
    duration: "Varies", level: "All Levels", language: "English",
    price: 0, original_price: 0, rating: 4.9,
    image_url: "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?auto=format&fit=crop&w=800&q=80",
    badge: "Academic Courses", tags: ["Maths"],
    contact_for_pricing: true, lessons: [],
  },
  {
    course_id: "c_science", slug: "science",
    title: "Science", category: "Academic Courses",
    short_description: "Comprehensive science coaching.",
    long_description: "All-in-one science program.",
    instructor_id: "i_sneha", instructor_name: "Sneha Iyer",
    instructor_avatar: "https://api.dicebear.com/7.x/personas/svg?seed=SnehaIyer",
    duration: "Varies", level: "All Levels", language: "English",
    price: 0, original_price: 0, rating: 4.8,
    image_url: "https://images.unsplash.com/photo-1532187643603-ba119ca4109e?auto=format&fit=crop&w=800&q=80",
    badge: "Academic Courses", tags: ["Science"],
    contact_for_pricing: true, lessons: [],
  },
  {
    course_id: "c_pd", slug: "personality-development",
    title: "Personality Development (PD)", category: "Skill Development",
    short_description: "Build magnetic confidence.",
    long_description: "Transformative program covering body language and voice.",
    instructor_id: "i_sneha", instructor_name: "Sneha Iyer",
    instructor_avatar: "https://api.dicebear.com/7.x/personas/svg?seed=SnehaIyer",
    duration: "Flexible", level: "All Levels", language: "English",
    price: 599, original_price: 1199, rating: 4.8,
    image_url: "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&w=800&q=80",
    badge: "Skill Development", tags: ["Confidence"],
    lessons: [],
  },
];

export default STATIC_COURSES;
